/**
 * HUMANSTARSapp
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const IAMGrant = {
    Allow: 'allow',
    Deny: 'deny',
    Inherit: 'inherit'
} as const;
export type IAMGrant = typeof IAMGrant[keyof typeof IAMGrant];

